<template>
  <Transition name="fade">
    <div
      v-if="showing"
      class="fixed pt-24 pb-10 inset-0 w-full h-screen flex items-center justify-center bg-semi-75 z-20"
    >
      <div class="mx-2 w-full max-w-2xl max-h-full bg-white shadow-lg rounded-lg p-8 overflow-auto">
        <div class="w-full text-right sticky top-0 right-0">
          <button aria-label="close" class="text-xl text-gray-500" @click.prevent="close">×</button>
        </div>      
        <div
          class="w-full text-left px-3 pb-3 text-teal-700 text-2xl font-bold"
        >Enviar evento a visitantes</div>

        <div class="flex flex-col items-center">
          <form class="w-full max-w-lg" @submit.prevent>
            <div class="flex flex-wrap -mx-3 mb-3">
              <div class="w-full px-3 mb-6 md:mb-0">
                <p style="font-size: 14px;" class="text-gray-700 text-xs font-bold mb-2 text-justify">
                    Se enviará notificación de evento a todos los visitantes de forma predeterminada, puede seleccionar los siguientes filtros opcionales
                    para hacerlo llegar a un sector de población específico.
                </p>
                <br>              
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="gender"
                >Género</label>
                <div class="relative">
                  <select
                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    name="gender"
                    id="gender"
                    v-model="gender"
                  >
                    <!-- <option disabled selected>Seleccione uno</option> -->
                    <option value="">Todos</option>
                    <option value="H">Masculino</option>
                    <option value="M">Femenino</option>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-3">
              <div class="w-5/12 px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="min_age"
                >Edad Mínima</label>
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="min_age"
                  type="text"
                  v-model="min_age"
                />
              </div>
              <div class="w-2/12 px-3 mb-6 md:mb-0">
                <div class="flex items-center justify-center h-full mt-2">a</div>
              </div>
              <div class="w-5/12 px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="max_age"
                >Edad Máxima</label>
                <input
                  class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
                  id="max_age"
                  type="text"
                  v-model="max_age"
                />
              </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-3">
              <div class="w-full px-3 mb-6 md:mb-0">
                <label
                  class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                  for="grade"
                >Nivel de Estudios</label>
                <div class="relative">
                  <select
                    class="block appearance-none w-full bg-gray-200 border border-gray-200 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    name="grade"
                    id="grade"
                    v-model="grade"
                  >
                    <!-- <option disabled selected>Seleccione uno</option> -->
                    <option value="">Todos</option>
                    <option value="Primaria">Primaria</option>
                    <option value="Secundaria">Secundaria</option>
                    <option value="Preparatoria">Preparatoria</option>
                    <option value="Universidad">Universidad</option>
                    <option value="Maestría">Maestría</option>
                    <option value="Doctorado">Doctorado</option>
                  </select>
                  <div
                    class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
                  >
                    <svg
                      class="fill-current h-4 w-4"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                    >
                      <path
                        d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                      />
                    </svg>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-full px-3 mb-6">
              <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2 text-left"
                for="area"
              >Área</label>
              <div class="h-64 w-full">
                <l-map
                  ref="map"
                  class="h-full w-full z-0"
                  :zoom="zoom"
                  :minZoom="11"
                  :center="center"
                  :maxBounds="maxBounds"
                  :options="{zoomControl: false}"
                  @ready="onMapReady"
                >
                  <l-geo-json :geojson="polygon" :options-style="geoStyle" />
                </l-map>
              </div>
            </div>

            <div class="flex w-full justify-end">
              <button
                class="bg-secondary-color hover:bg-secondary-color-dark px-4 py-2 text-center rounded-lg text-white tracking-wide"
                @click="sendEvent()"
              >Enviar</button>
              <button
                class="ml-2 bg-red-500 hover:bg-danger-color px-4 py-2 text-center rounded-lg text-white tracking-wide"
                @click="close()"
              >Cerrar</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>

import config from "../../vue.config.js";
import polygon from "../assets/polygonChapp.json";

import { LMap, LGeoJson } from "vue2-leaflet";
import LDraw from "leaflet-draw";
import * as esri from "esri-leaflet";

import drawLocales from "leaflet-draw-locales";

export default {
  name: "send-event-modal",
  data() {
    return {
      gender: "",
      min_age: null,
      max_age: null,
      grade: "",
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken")
        }
      },
      maxBounds: [
        [19.395295944890695, -99.22922388422747],
        [19.43212847837641, -99.17403475153704]
      ],
      polygon: polygon,
      zoom: 13,
      center: [19.412257, -99.200871],
      showMarker: false,
      geoStyle: {
        color: "#cb2833",
        fill: false
      },
      eventArea: null
    };
  },
  props: {
    showing: {
      required: true,
      type: Boolean
    },
    eventId: {
      required: true
    },
    eventName: {
      required: true
    }
  },
  components: {
    LMap,
    LGeoJson
  },
  watch: {
    showing(value) {
      if (value) {
        return document.querySelector("body").classList.add("overflow-hidden");
      }

      document.querySelector("body").classList.remove("overflow-hidden");
    }
  },
  methods: {
    onMapReady: function() {
      this.$nextTick(() => {
        const map = this.$refs.map.mapObject;
        esri.basemapLayer("Topographic").addTo(map);
        const editableLayers = new window.L.FeatureGroup().addTo(map);
        const drawControl = new window.L.Control.Draw({
          position: "topright",
          draw: {
            polyline: false,
            polygon: true,
            rectangle: false,
            circle: false,
            marker: false,
            circlemarker: false
          }
        });

        const drawControlEditOnly = new window.L.Control.Draw({
          position: "topright",
          draw: {
            polyline: false,
            polygon: false,
            rectangle: false,
            circle: false,
            marker: false,
            circlemarker: false
          },
          edit: {
            featureGroup: editableLayers
          }
        });

        map.addControl(drawControl);

        map.on("draw:created", e => {
          var layer = e.layer;
          this.eventArea = layer.toGeoJSON().geometry;
          layer.addTo(editableLayers);
          map.removeControl(drawControl);
          drawControlEditOnly.addTo(map);
        });

        map.on("draw:edited", e => {
          let layers = e.layers;
          layers.eachLayer(layer => {
            this.eventArea = layer.toGeoJSON().geometry;
          });
        });

        map.on("draw:deleted", e => {
          this.eventArea = null;
          map.removeControl(drawControlEditOnly);
          drawControl.addTo(map);
        });
      });
    },
    close() {
      this.$emit("close", "dismiss");
    },
    sendEvent() {
      let wkt = null;

      try {
        wkt = this.convertGeoJSON_WKT(this.eventArea);
      } catch (error) {}

      this.axios
        .post("apidev/api/events/send/" + this.eventId, {
          sex: this.gender,
          min_age: parseInt(this.min_age),
          max_age: parseInt(this.max_age),
          level_studies: this.grade,
          wkt: wkt
        })
        .then(response => {
          return this.axios.post("apidev/api/binnacles/monitor/save/",{
            "module": "Eventos", 
            "action": "Envío de evento a visitantes", 
            "observation": `Evento: ${ this.eventName }`,
            "email": localStorage.getItem("email")
            },
            this.config
          )
        })
        .then(response => {
          this.gender = "";
          this.min_age = null;
          this.max_age = null;
          this.grade = "";
          this.$emit("close");
        })
        .catch(error => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
    convertGeoJSON_WKT(polygon) {
      var wkt_str =
        "POLYGON(" +
        polygon.coordinates
          .map(function(ring) {
            return (
              "(" +
              ring
                .map(function(p) {
                  return p[0] + " " + p[1];
                })
                .join(", ") +
              ")"
            );
          })
          .join(", ") +
        ")";
      return wkt_str;
    }
  }
};
</script>

<style scoped>
.bg-semi-75 {
  background-color: rgba(0, 0, 0, 0.75);
}
</style>
